





































































import Vue from 'vue'
import WeaponAttack from '../../components/_WeaponAttack.vue'

export default Vue.extend({
  name: 'skirmish-dialog',
  components: { WeaponAttack },
  props: {
    item: {
      type: Object,
      required: false,
      default: null,
    },
    mech: {
      type: Object,
      required: true,
    },
    mount: {
      type: Object,
      required: false,
      default: null,
    },
    overwatch: {
      type: Boolean,
    },
  },
  data: () => ({
    dialog: false,
    confirmedFree: false,
  }),
  computed: {
    extraAux() {
      if (this.mount.Weapons.length === 1) return null
      else {
        const extra = this.mount.Weapons.find(x => x !== this.item)
        return extra || null
      }
    },
  },
  methods: {
    confirmAttack(free) {
      this.confirmedFree = free
      this.$emit('confirm', free)
    },
    reset() {
      this.$refs.main.reset()
      if (this.extraAux) this.$refs.aux.reset()
    },
    init() {
      this.$refs.main.init()
    },
    confirm(): void {
      if (this.confirmedFree) this.reset()
      this.confirmedFree = false
      this.dialog = false
      this.$emit('close')
      this.$refs.main.init()
    },
    show(): void {
      this.dialog = true
    },
    hide(): void {
      if (this.confirmedFree) this.reset()
      this.confirmedFree = false
      this.dialog = false
      this.$emit('close')
      this.$refs.main.init()
    },
  },
})
